import ta_launcher from "./http_launcher_producer";
import TAUtils from "./ta_utils";
import PG from "./ta_pg";
import TAUI from "./ui/ta_ui";
import { executeOnUpgradeIgnored } from "./ui/ta_upgrade_functions";
import { getRemoteNodes } from "./configResolver";

export default class TA_INIT {
  static remoteServersProvided = () => {
    let provided = true;
    let remoteNodes = getRemoteNodes();
    for (let key in remoteNodes) {
      let serverConf = remoteNodes[key];
      if (serverConf.pgpMessage.length <= 0) {
        if (serverConf.remoteServer.length <= 0) {
          provided = false;
          break;
        }
      }
    }
    return provided;
  };

  static versionCheck = (executeAfterVersionCheck, executeOnUpgradeIgnored) => {
    let successHandler = function (data) {
      PG.state.currentVersion = JSON.stringify(data);
      TAUtils.apiChecks(data);
      //update the service status of TA
      if (PG.available.serviceStatus) {
        TAUtils.checkRunningAsService(TAUtils.runningAsServiceStatusGetSet);
      }
      if (PG.localConfig.declineUpgrade !== PG.state.currentVersion) {
        if (TAUtils.compareVersion(data, PG.version) < 0) {
          TAUI.upgrade(executeAfterVersionCheck, executeOnUpgradeIgnored);
        } else {
          executeAfterVersionCheck();
        }
      } else {
        executeAfterVersionCheck();
      }
    };
    PG.getVersionAjax(successHandler);
  };

  static afterTaConfirmed = (
    executeAfterVersionCheck = () => true,
    upgradeIgnored = executeOnUpgradeIgnored
  ) => {
    // pg.launcher has to exist. If it doesn't, none of this works anyhow.
    ta_launcher.setLocal("ta_found", "true");

    PG.state.applicationLaunched = true;

    // Check version
    // **** important: versionCheck is a gatekeeper! It will continue initialization
    // **** once user has downloaded or declined!
    TA_INIT.versionCheck(executeAfterVersionCheck, upgradeIgnored);
  };
}
